"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const queryString = require("query-string");
function request(options, cb) {
    let path = options.url;
    if (options.qs) {
        const stringified = queryString.stringify(options.qs);
        if (stringified)
            path += "?" + stringified;
    }
    let body = options.body;
    if (options.json) {
        body = JSON.stringify(body);
        options.headers['Content-Type'] = 'application/json';
    }
    let opts = {
        method: options.method,
        body: body,
        signal: options.signal,
        headers: Object.assign({}, options.headers, { "User-Agent": options.user_agent }),
        credentials: "include"
    };
    fetch(path, opts).then(response => {
        response.json().then(json => {
            cb(undefined, response, json);
        }).catch(err => {
            cb(undefined, response, {});
        });
    }).catch(err => {
        cb(err, undefined, undefined);
    });
}
exports.request = request;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bpm-client-api/lib/requests/native_request.js
// module id = 950
// module chunks = 0